<template>
  <div class="akvamir">
    <div>
      <!--
      <answer answer-title="Проблема" answer-theme="problem" answer-words="(не пришли билеты, нет чека, не правильно указана почта, деньги списались а ни..." :answer-id=scenario.parameters.problemId :answer-audio=scenario.parameters.problemAudio v-bind:answer-text.sync="scenario.parameters.problemText" is-generation="true" />
      <answer answer-title="Отдел продаж" answer-theme="saleDepartment" answer-words="(купить много билетов, корпоративная скидка, автобусные туры, юр лицо..." :answer-id=scenario.parameters.saleDepartmentId :answer-audio=scenario.parameters.saleDepartmentAudio :answer-text=scenario.parameters.saleDepartmentText is-generation="true" />
      <answer answer-title="Администратор" answer-theme="administrator" answer-words="(забыл, цепочка, кольцо, сережки, пропал, украли, оставил, гардероб)" :answer-id=scenario.parameters.administratorId :answer-audio=scenario.parameters.administratorAudio :answer-text=scenario.parameters.administratorText is-generation="true" />
      <answer answer-title="Тариф" answer-theme="tariff" answer-words="(цена билета, поход, стоимость,заплатить, сколько, стоит, билет, вечерний, утренний..." :answer-id=scenario.parameters.tariffId :answer-audio=scenario.parameters.tariffAudio :answer-text=scenario.parameters.tariffText is-generation="true" />
      <answer answer-title="Маршрут" answer-theme="route" answer-words="(доехать, адрес, добраться, вокзал, автовокзал, проехать, автобус, маршрутка..." :answer-id=scenario.parameters.routeId :answer-audio=scenario.parameters.routeAudio :answer-text=scenario.parameters.routeText is-generation="true" />
      <answer answer-title="Акция" answer-theme="stock" answer-words="(скидка, спецпредложения, акция, дёшево, предложения, день рождения, именинник..." :answer-id=scenario.parameters.stockId :answer-audio=scenario.parameters.stockAudio :answer-text=scenario.parameters.stockText is-generation="true" />
      <answer answer-title="Принадлежности" answer-theme="accessories" answer-words="(брать с собой, полотенце, тапочки, шапочка, жилет, круг, памперсы..." :answer-id=scenario.parameters.accessoriesId :answer-audio=scenario.parameters.accessoriesAudio :answer-text=scenario.parameters.accessoriesText is-generation="true" />
      <answer answer-title="Льгота" answer-theme="benefits" answer-words="(многодетная, инвалид, участник, ветеран,боевых действий, Афганец, Чечня, Сирия..." :answer-id=scenario.parameters.benefitsId :answer-audio=scenario.parameters.benefitsAudio :answer-text=scenario.parameters.benefitsText is-generation="true" />
      <answer answer-title="Группа" answer-theme="group" answer-words="(туры, группы, групповые, групповой, класс, много человек, коллектив, компания)" :answer-id=scenario.parameters.groupId :answer-audio=scenario.parameters.groupAudio :answer-text=scenario.parameters.groupText is-generation="true" />
      <answer answer-title="Возврат" answer-theme="return" answer-words="(вернуть деньги, не смог посетить)" :answer-id=scenario.parameters.returnId :answer-audio=scenario.parameters.returnAudio :answer-text=scenario.parameters.returnText is-generation="true" />
      <answer answer-title="Сертификат" answer-theme="certificate" answer-words="(подарок, подарочный, доплата, срок годности)" :answer-id=scenario.parameters.certificateId :answer-audio=scenario.parameters.certificateAudio :answer-text=scenario.parameters.certificateText is-generation="true" />
      <answer answer-title="Все вопросы" answer-theme="all_questions" :answer-id=scenario.parameters.allQuestionsId :answer-audio=scenario.parameters.allQuestionsAudio :answer-text=scenario.parameters.allQuestionsText is-generation="true" />
-->
      <div v-for="answer of scenario.parameters.answers" class="answer_shell" :class="answer.theme === 'start' ? 'start' : ''">
        <answer
          :answer-title=answer.title
          :answer-theme=answer.theme
          :answer-words=answer.words
          v-bind:answer-audio.sync="answer.audio"
          v-bind:answer-text.sync="answer.text"
          v-bind:answer-speaker.sync="answer.speaker"
          v-bind:answer-emotion.sync="answer.emotion"
          v-bind:answer-speed.sync="answer.speed"

          :is-saved=isSaved
          :client=scenario.client

          @generateAudioHandler="setAudio"
          @deleteAudioHandler="deleteAudio"
        />
      </div>
    </div>
    <div>
      <scenario-bar
        :name="name"
        v-bind:is-saved=isSaved
        :is-ready=scenario.isReady
        v-bind:scenario="scenario"
        @set="setScenario"
      />
    </div>
  </div>
</template>

<script>
  import Answer from '../Answer'
  import ScenarioBar from './ScenarioSaver'
  export default {
    props: ['name', 'campaignid'],
    components: {ScenarioBar, Answer},
    data() {
      return {
        scenario: {
          template: 'akvamir',
          client: '',
          parameters: {
            mainQuestionId: '',
            mainQuestionAudio: [],
            mainQuestionText: '',
            mainGenerationState: true,

            answers:[
              {
                  audio: [],
                  text: '',
                  generationState: true,
                  title: 'Начало разговора',
                  theme: 'start',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Проблема',
                words: '(не пришли билеты, нет чека, не правильно указана почта, деньги списались а ни...',
                theme: 'some_problem',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Отдел продаж',
                words: '(купить много билетов, корпоративная скидка, автобусные туры, юр лицо...',
                theme: 'sale_department',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Администратор',
                words: '(забыл, цепочка, кольцо, сережки, пропал, украли, оставил, гардероб)',
                theme: 'administrator',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Тариф',
                words: '(цена билета, поход, стоимость,заплатить, сколько, стоит, билет, вечерний, утренний...',
                theme: 'tariff',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Маршрут',
                words: '(доехать, адрес, добраться, вокзал, автовокзал, проехать, автобус, маршрутка...',
                theme: 'route',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Акция',
                words: '(скидка, спецпредложения, акция, дёшево, предложения, день рождения, именинник...',
                theme: 'stock',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Принадлежности',
                words: '(брать с собой, полотенце, тапочки, шапочка, жилет, круг, памперсы...',
                theme: 'accessories',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Льгота',
                words: '(многодетная, инвалид, участник, ветеран,боевых действий, Афганец, Чечня, Сирия...',
                theme: 'benefits',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Группа',
                words: '(туры, группы, групповые, групповой, класс, много человек, коллектив, компания)',
                theme: 'group',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Возврат',
                words: '(вернуть деньги, не смог посетить)',
                theme: 'return',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                  audio: [],
                  text: '',
                  generationState: true,
                  title: 'Сертификат',
                  words: '(подарок, подарочный, доплата, срок годности)',
                  theme: 'certificate',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                  audio: [],
                  text: '',
                  generationState: true,
                  title: 'Динопарк',
                  words: '(динопарк, динозавр, юрского, шоу доисторических животных)',
                  theme: 'dinosaurs',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                  audio: [],
                  text: '',
                  generationState: true,
                  title: 'Правила',
                  words: '(правила, поведение)',
                  theme: 'rules',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              },
              {
                audio: [],
                text: '',
                generationState: true,
                title: 'Все вопросы',
                words: '',
                theme: 'all_questions',
                  speaker: 'oksana',
                  emotion: 'neutral',
                  speed: 1
              }
            ]

          },
          checkDuration: true,
          isReady: false
        },

        isSaved: false
      }
    },
    methods: {
      setScenario(value) {
        if (value) {
            for (let i = 0; i < value.parameters.answers.length; i++) {
               value.parameters.answers[i].speaker = value.parameters.answers[i].speaker || 'oksana'
               value.parameters.answers[i].emotion = value.parameters.answers[i].emotion || 'neutral'
               value.parameters.answers[i].speed = value.parameters.answers[i].speed || 1
            }
            if (value.parameters.answers.length && value.parameters.answers[0].theme !== 'start') {
                value.parameters.answers.unshift({
                    audio: [],
                    text: '',
                    generationState: true,
                    title: 'Начало разговора',
                    theme: 'start',
                    speaker: 'oksana',
                    emotion: 'neutral',
                    speed: 1
                })
            }
            if (value.parameters.answers.length && value.parameters.answers[value.parameters.answers.length - 2].theme !== 'rules') {
                value.parameters.answers.splice(value.parameters.answers.length - 1, 0, {
                    audio: [],
                    text: '',
                    generationState: true,
                    title: 'Динопарк',
                    words: '(динопарк, динозавр, юрского, шоу доисторических животных)',
                    theme: 'dinosaurs',
                    speaker: 'oksana',
                    emotion: 'neutral',
                    speed: 1
                })
                value.parameters.answers.splice(value.parameters.answers.length - 1, 0, {
                    audio: [],
                    text: '',
                    generationState: true,
                    title: 'Правила',
                    words: '(правила, поведение)',
                    theme: 'rules',
                    speaker: 'oksana',
                    emotion: 'neutral',
                    speed: 1
                })
            }
        }
        this.scenario = value
        if (!this.isSaved) {
          this.isSaved = true
        }
      },
      setAudio(data) {
        let answer = this.getAnswerObjByClass(data.theme)
        if (answer) {
          if (data.type) {
            let audio = {
              type: data.type,
              url: data.url,
              param: data.paramName,
              number: data.number
            }
            answer.audio = answer.audio || []
            let audioTmp = []
            audioTmp.push(audio)
            for (let i = 0; i < answer.audio.length; i++) {
              audioTmp.push(answer.audio[i])
            }
            audioTmp.sort((a, b) => (a.number > b.number) ? 1 : -1)
            answer.audio = audioTmp
          } else {
            answer.audio = []
          }
        }
      },
      deleteAudio(data) {
        let answer = this.getAnswerObjByClass(data.theme)
        if (answer) {
          answer.audio[0].url = null
        }
      },
      getAnswerObjByClass(answerTheme) {
        for (let i = 0; i < this.scenario.parameters.answers.length; i++) {
          let answer = this.scenario.parameters.answers[i]
          if (answer.theme.toLocaleLowerCase() === answerTheme.toLowerCase()) {
            return answer
          }
        }
      }
    }
  }
</script>

<style scoped>
  .answer_shell {
    max-width: 512px;
    display: inline-block;
    margin-right: 32px;
    margin-top: 50px;
    vertical-align: top;
    /*border: 1px double black; !* Параметры границы *!*/
    background-color: ghostwhite;
    padding: 10px;
  }

  .answer_shell.start {
    display:block;
    margin-left: auto;
    margin-right: auto;
    /*margin-top: -32px;*/
    max-width: 900px;
    min-height: 120px;
    height: 194px;
  }

  .answer_shell.start textarea{
    height: 64px;
    min-height: 64px;
  }

</style>

<style>
  .akvamir .answer .generation_radios {
    display: none;
  }
  .akvamir .generation_radios {
    display: none;
  }
  .akvamir input[type=range].slider.is-small {
    width: 110px;
  }
  .akvamir .generate_audio_control {
    margin-top: 10px;
  }

  .akvamir .player {
    width: 85%;
    max-width: 420px;
  }
  .akvamir .player .player-progress {
    width: 256px;
  }

  .akvamir .player .volume input {
    width:53px;
  }

  .akvamir .start textarea{
    height: 56px;
    min-height: 56px;
  }
</style>




// WEBPACK FOOTER //
// ScenarioAkvamir.vue?14920262